import lodash from 'lodash';

import { RootState } from '@modules';
import { createAction, createSlice, PayloadAction, Selector } from '@reduxjs/toolkit';
import UserProfileEntity from './profileEntity';

interface IStore {
  statusLogin?: boolean;
  user?: UserProfileEntity;
  listPermissionCode?: Array<string>;
}
export const removeProfile = createAction('authentication/removeProfile');
export const setToken = createAction<{ token: any; refreshToken: any; remember?: boolean }>(
  'authentication/setToken',
);

interface IStore {
  statusLogin?: boolean;
  user?: UserProfileEntity;
  listPermissionCode?: Array<string>;
  token?: string;
  refreshToken?: string;
  remember: boolean;
}

const profileStore = createSlice({
  name: 'profileStore',
  initialState: {
    statusLogin: false,
    user: null,
    listPermissionCode: [],
    token: null,
    refreshToken: null,
    remember: false,
  } as unknown as IStore,
  reducers: {
    fetchProfile: (state, action: PayloadAction<{ user?: any; listPermissionCode?: string[] }>) =>
      Object.assign(state, {
        statusLogin: action.payload.user != null,
        user: action.payload.user,
        listPermissionCode: action.payload.listPermissionCode || [],
      }),
    resetToken: (state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) =>
      Object.assign(state, {
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      }),
    updateProfile: (
      state,
      action: PayloadAction<{
        listPermissionCode?: string[];
        statusLogin?: boolean;
      }>,
    ) => Object.assign(state, action.payload),
    logOut: (state: any) => {
      return {
        ...state,
        statusLogin: false,
        user: null,
        token: null,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(removeProfile, (state: any) => {
        return {
          ...state,
          statusLogin: false,
          user: null,
          listPermissionCode: [],
          token: null,
          remember: false,
        };
      })
      .addCase(setToken, (state, action) =>
        Object.assign(state, action.payload, {
          statusLogin: !lodash.isEmpty(action.payload.token),
        }),
      );
  },
});

export const TokenSelector: Selector<RootState, string> = state => {
  return state.profile.token || '';
};

interface IUser {
  user?: any;
  status: boolean;
}

export const UserSelector: Selector<RootState, IUser> = state => {
  return {
    user: state.profile.user,
    status: state.profile.statusLogin || false,
  };
};

interface IPermissions {
  listPermissionCode: string[];
  status: boolean;
}
export const PermissionsSelector: Selector<RootState, IPermissions> = state => {
  return {
    listPermissionCode: state.profile.listPermissionCode || [],
    status: state.profile.statusLogin || false,
  };
};

export default profileStore;
